import { render, staticRenderFns } from "./create-ticket.vue?vue&type=template&id=12218eed&scoped=true&"
import script from "./create-ticket.vue?vue&type=script&lang=js&"
export * from "./create-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12218eed",
  null
  
)

export default component.exports